import { useState } from "react";
import type { PageContent } from "../../types/page-content";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileCallButton from "./MobileCallButton";
import EstimateModal from "./EstimateModal";
import HeroSection from "../sections/HeroSection";
import TrustBarSection from "../sections/TrustBarSection";
import ServicesSection from "../sections/ServicesSection";
import AIAnswerSection from "../sections/AIAnswerSection";
import ProcessSection from "../sections/ProcessSection";
import WhyChooseUsSection from "../sections/WhyChooseUsSection";
import ServiceAreaSection from "../sections/ServiceAreaSection";
import TestimonialsSection from "../sections/TestimonialsSection";
import FAQSection from "../sections/FAQSection";
import FinalCTASection from "../sections/FinalCTASection";

interface Props {
  content: PageContent;
}

export default function PageTemplate({ content }: Props) {
  const [estimateOpen, setEstimateOpen] = useState(false);
  const open = () => setEstimateOpen(true);
  const close = () => setEstimateOpen(false);

  return (
    <div className="min-h-screen bg-[#111111] font-body">
      <Navbar onEstimateClick={open} />

      {/* Section 1 */}
      <HeroSection content={content.hero} onEstimateClick={open} />
      {/* Section 2 */}
      <TrustBarSection />
      {/* Section 3 */}
      <ServicesSection content={content.services} onEstimateClick={open} sectionNumber="02" />
      {/* Section 4 */}
      <AIAnswerSection content={content.aiAnswer} sectionNumber="03" />
      {/* Section 5 */}
      <ProcessSection content={content.process} sectionNumber="04" />
      {/* Section 6 */}
      <WhyChooseUsSection content={content.whyChooseUs} onEstimateClick={open} sectionNumber="05" />
      {/* Section 7 */}
      <ServiceAreaSection content={content.serviceArea} sectionNumber="06" />
      {/* Section 8 */}
      <TestimonialsSection content={content.testimonials} sectionNumber="07" />
      {/* Section 9 */}
      <FAQSection content={content.faq} onEstimateClick={open} sectionNumber="08" />
      {/* Section 10 */}
      <FinalCTASection content={content.finalCta} onEstimateClick={open} sectionNumber="09" />

      <Footer />
      <MobileCallButton />
      <EstimateModal open={estimateOpen} onClose={close} />
    </div>
  );
}
